export function toMillis(value) {
    if (value instanceof Date) {
        const millis = value.getTime();
        return Number.isFinite(millis) ? millis : undefined;
    }
    return typeof value === 'number' && Number.isFinite(value) ? value : undefined;
}
